<template>

	<div>

			<span v-for="elitem in portada">
				<span v-if="elitem.acf.template_seccion=='slideportada'">
					<slideportada :post_id="elitem.id"></slideportada>
				</span>

				<span v-if="elitem.acf.template_seccion=='versiculosdeldia'">
					<versiculosdeldia></versiculosdeldia>
				</span>

				<span v-if="elitem.acf.template_seccion=='audios'">
					<audiosportada :post_id="elitem"></audiosportada>
				</span>

				<span v-if="elitem.acf.template_seccion=='img_link'">
					<imglinkportada :post_id="elitem"></imglinkportada>
				</span>

				<span v-if="elitem.acf.template_seccion=='categoria'">
					<categoriaportada :post_id="elitem"></categoriaportada>
				</span>

				<section class="col-xs-12" v-if="elitem.acf.template_seccion=='versiculos'">
					<versiculosdeldia></versiculosdeldia>
				</section>

				<span v-if="elitem.acf.template_seccion=='encuesta'">
					<encuestasportada></encuestasportada>
				</span>
			</span>

	</div>

</template>

<script>
export default {

	mounted: function() {
		const vm = this;
		vm.getPortada();
		vm.pageDescripcion = vm.pageDescripcion;
		vm.$store.commit( 'rtChangeTitle', vm.pageDescripcion );
	},

	data() {
		return {
			base_path: rtwp.base_path,
			pageDescripcion: rtwp.site_description,
			theme_url:rtwp.theme_url,
			portada:[],
		};
	},
	methods: {
		getPortada: function() {
			const vm = this;
			vm.$http.get( 'wp/v2/portada?order=asc&orderby=menu_order')
			.then( ( res ) => {
				vm.portada = res.data;
				vm.loaded = 'true';
				vm.$nextTick(function(){
					// console.log(vm.portada);
					init_attach();
				});



			} )
			.catch( ( res ) => {
				//console.log( `Something went wrong : ${res}` );
			} );
		}
	}
};
</script>



// WEBPACK FOOTER //
// portada.vue?740bc678